import React from 'react';
import {
  Button,
  CircularProgress,
  FormControlLabel,
  Hidden,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  withStyles,
} from '@material-ui/core';
import styles from '../common/Table/styles';
import Loading from '../common/Loading';
import SectionHeader from '../common/SectionHeader';
import Surface from '../common/Surface';
import ReactJson from 'react-json-view';

export const ROWS_PER_PAGE = 50;

const AuditLogsComponent = ({
  classes,
  data,
  page,
  dataCount,
  loading,
  updating,
  columns,
  handleChangePage,
  filters,
  setFilters,
  applyFilters,
  successMessage,
  loadingMore,
  title,
  enableDuplicate,
}) => {
  const renderTableHeader = () =>
    columns.map(column => {
      const Cell = () => (
        <TableCell
          style={{ color: '#353535de', minWidth: column.minWidth }}
          classes={{ root: classes.tableHead }}
        >
          {column.label}
        </TableCell>
      );

      if (column.hidden) {
        return (
          <Hidden key={column.id} {...column.hidden}>
            <Cell />
          </Hidden>
        );
      } else {
        return <Cell key={column.id} />;
      }
    });

  const renderTableRow = row =>
    columns.map(column => {
      const cellProps = {
        key: column.id,
        classes: { root: classes.tableCell },
      };

      if (column.hidden) {
        return (
          <Hidden key={column.id} {...column.hidden}>
            <TableCell {...cellProps}>
              {column.field && row[column.id] ? row[column.id][column.field] : row[column.id]}
            </TableCell>
          </Hidden>
        );
      } else {
        if (column.field === 'affectedEntity') {
          return (
            <TableCell {...cellProps}>
              { row[column.id] ? <ReactJson src={row[column.id]}  name={'Detalle'} collapsed={true} collapseStringsAfterLength={50} displayDataTypes={false} /> : '' }
            </TableCell>
          )
        } else if (column.field === 'user') {
          return (
            <TableCell {...cellProps}>
              {row[column.id] ? row[column.id].firstName + ' ' + row[column.id].lastName : ''}
            </TableCell>
          );
        }
        return (
          <TableCell {...cellProps}>
            {column.field && row[column.id] ? row[column.id][column.field] : row[column.id]}
          </TableCell>
        );
      }
    });

  return (
    <div>
      <SectionHeader title={title}></SectionHeader>
      <Surface id="filters-section" style={{ marginBottom: "15px", padding: "12px 20px 12px 20px" }}>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <Typography style={{ marginBottom: "15px" }}>Filtros</Typography>
          <div>
            <FormControlLabel
              control={
                <Switch
                  checked={filters.showSessionLogs}
                  onChange={e => setFilters({ ...filters, showSessionLogs: e.target.checked })}
                  name="sessionLogsFilter"
                  color="primary"
                />
              }
              label="Mostrar logs de sesion"
            />
          </div>
          <Button onClick={applyFilters} variant="contained" color="primary" size="small" style={{ width: "150px", marginTop: "15px" }}>Aplicar filtros</Button>
        </div>
      </Surface>
      <Surface className={classes.root}>
        {loading ? (
          <Loading style={{ height: 639 }} />
        ) : (
          <div>
            <TableContainer style={{ borderRadius: 4 }}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {renderTableHeader()}
                    <TableCell classes={{ root: classes.tableHead }} style={{ minWidth: 200 }}>
                      {updating && <CircularProgress size={24} style={{ marginRight: 20 }} />}
                    </TableCell>
                  </TableRow>
                </TableHead>
                {loadingMore ? (
                  <caption style={{ padding: 0, color: 'black', height: 520 }}>
                    <Loading style={{ height: 520 }} />
                  </caption>
                ) : (
                  <TableBody>
                    {data
                      .map(row => {
                        return (
                          <TableRow
                            hover
                            tabIndex={-1}
                            key={row._id}
                          >
                            {renderTableRow(row)}
                            <TableCell
                              style={{ paddingTop: 2, paddingBottom: 2 }}
                              classes={{ root: classes.tableCell }}
                            >
                            </TableCell>
                          </TableRow>
                        );
                      })}
                  </TableBody>
                )}
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[ROWS_PER_PAGE]}
              component="div"
              count={dataCount}
              rowsPerPage={ROWS_PER_PAGE}
              page={page}
              labelDisplayedRows={({ from, to, count }) => from + ' al ' + to + ' de ' + count}
              onChangePage={handleChangePage}
              classes={{ root: classes.pagination }}
            />
          </div>
        )}
      </Surface>
    </div>
  );
};

export default withStyles(styles)(AuditLogsComponent);
